export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-3">随时随地，畅享漫画</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              UU漫画移动端体验全面优化，韩漫推荐、日漫大全、国漫排行榜随时随地一手掌握。
              无论通勤路上还是睡前时光，好看的漫画永远在线。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a href="#" className="inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-background-50 px-6 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg" />
                App Store
              </a>
              <a href="#" className="inline-flex items-center gap-2 bg-foreground-900 hover:bg-foreground-800 text-background-50 px-6 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-google-play-fill text-lg" />
                Google Play
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 bg-background-200 rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20modern%20QR%20code%20design%20on%20white%20background%20with%20comic%20style%20decorative%20elements%2C%20minimalist%2C%20warm%20orange%20accents%2C%20simple%20geometric%20pattern&width=448&height=448&seq=app-qr&orientation=squarish"
              alt="UU漫画移动端下载"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}